import { render, staticRenderFns } from "./AddCompanyAsTrusteeBtn.vue?vue&type=template&id=404cb45e&scoped=true"
import script from "./AddCompanyAsTrusteeBtn.vue?vue&type=script&lang=js"
export * from "./AddCompanyAsTrusteeBtn.vue?vue&type=script&lang=js"
import style0 from "./AddCompanyAsTrusteeBtn.vue?vue&type=style&index=0&id=404cb45e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404cb45e",
  null
  
)

export default component.exports